import { isObject } from 'lodash'

import type { ArrayValue, IArrayChangeMeta } from './types'

export const isArrayValue = (value: unknown): value is ArrayValue =>
  isObject(value) && 'value' in value && typeof value.value === 'string'
export const isArrayValues = (value: unknown): value is ArrayValue[] =>
  Array.isArray(value) && value.every(isArrayValue)
export const isArrayMeta = <V extends ArrayValue>(value: unknown): value is IArrayChangeMeta<V> =>
  isObject(value) && 'command' in value && typeof value.command === 'string' && 'item' in value
